export const IMAGE_FORMATS = ['image/*'];

export const HEADSHOT_FORMATS = [
  ...IMAGE_FORMATS,
  'application/pdf',
];

export const RESUME_FORMATS = [
  'application/pdf',
  ...IMAGE_FORMATS,
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
];

export const RESUME_MAX_SIZE = 8 * 1024 * 1024;

export const DOCUMENT_FORMATS = [
  'application/pdf',
  ...IMAGE_FORMATS,
];

export const DOCUMENT_MAX_SIZE = 12 * 1024 * 1024;

export const PREDEFINED_TITLES = [
  'Contact sheet',
  'Rehearsal schedule',
  'Show schedule',
  'Scene breakdown',
];

export const FULL_HEIGHT_DISABLE_RULE = 'screen and (max-width: 1023px)';

export const CREATIVE_EDITABLE_PROSPECT_STATUSES = ['UNREVIEWED', 'REJECTED', 'POSSIBLE', 'CALLBACK', 'NOT_OFFERED'];

export const CREATIVE_UNLOCKED_ROLE_STATUSES = ['OPEN', 'NOT_NEEDED', 'READY', 'OFFERED', 'ACCEPTED'];

export const EXPOSED_PROSPECT_STATUSES = ['PITCHED', 'READY', 'OFFERED', 'ACCEPTED'];

export const UNASSIGN_ROLE_PROSPECT_STATUSES = ['UNAVAILABLE', 'DECLINED'];
